import React from "react";
import { Link } from "react-router-dom";

const ArrowRight = () => (
  <svg
    className="cat-card-cta-arrow"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path
      d="M1 6h10M7 1l5 5-5 5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CornerSvg = () => (
  <svg
    className="cat-card-corner"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 2h32v32" stroke="white" strokeWidth="1.2" />
    <path
      d="M2 2v32h32"
      stroke="white"
      strokeWidth="0.5"
      strokeDasharray="3 3"
    />
    <circle cx="18" cy="18" r="5" stroke="white" strokeWidth="0.8" />
  </svg>
);

function Card({ item, featured = false, variant = "regular", cardRef }) {
  if (!item) return null;

  const hasVideo = !!item.video;
  const slug = item.slugPath || item.slug;

  // Determine CSS class
  const sizeClass = featured
    ? "cat-card--featured"
    : variant === "list"
      ? "cat-card--list"
      : "cat-card--regular";

  return (
    <>
      <Link
        to={`/categories/${slug}`}
        className={`cat-card ${sizeClass}`}
        ref={cardRef}
      >
        {/* Background media */}
        {hasVideo ? (
          <video
            className="cat-card-video"
            autoPlay
            muted
            loop
            playsInline
            aria-hidden="true"
          >
            <source src={item.video} type="video/mp4" />
          </video>
        ) : (
          item.image && (
            <img
              src={item.image}
              alt={item.name || item.title}
              className="cat-card-image"
              loading="lazy"
            />
          )
        )}

        {/* Overlay */}
        <div className="cat-card-overlay" aria-hidden="true" />

        {featured && <CornerSvg />}

        {/* Content */}
        <div className="cat-card-content">
          <div className="cat-card-middle">
            <span className="cat-card-subtitle">{item.subtitle}</span>
          </div>

          <div className="cat-card-footer">
            <div>
              <h3 className="cat-card-title">{item.name}</h3>
            </div>

            <div className="cat-card-arrow">
              <ArrowRight />
            </div>
          </div>
        </div>
      </Link>
    </>
  );
}

export default Card;
